export enum PAGE_ROUTES {
  LOGIN = 'login',
  REGISTER = 'register',
  REGISTRATION = 'registration',
  WELCOME = 'welcome',
  AGE_RESTRICTED = 'age-restricted',
  CALLBACK = 'callback',
  CREATE_ACCOUNT = 'create-account',
  BRANDS = 'brands',
  MARKETING = 'marketing',
  WALLET = 'wallet',
  LOCATIONS = 'locations',
  EVENTS = 'events',
  CAMPAIGNS = 'campaigns',
  USERS = 'users',
  CUSTOMERS = 'customers',
  PROMOS = 'promos',
  OFFERS = 'offers',
  ADMIN_OFFERS = 'admin-offers',
  MERCHANT_OFFERS = 'merchant-offers',
  BRANDS_OFFERS = 'brands-offers',
  AMBASSADOR_OFFERS = 'ambassador-offers',
  LINK_LOCATIONS = 'link-locations',
  CREATE_LOCATIONS = 'create-locations',
  CONTACT_US = 'contact',
  NOTIFICATIONS_CENTER = 'notifications-center',
  ACCOUNTS = 'accounts',
  LOADING = 'loading',
  AUTH = 'auth',
  HELPDESK = 'helpdesk',
  HISTORY = 'history',
  SEGMENTS = 'segments',
  AUDIENCES = 'audiences',
  EMAIL_MESSAGES = 'email-messages',
  PUSH_MESSAGES = 'push-messages',
  ACCOUNT = 'account',
  MANAGE_USERS = 'manage-users',
  ROLES = 'roles',
  CHANGE_PASSWORD = 'change-password',
  WAIT = 'wait',
  BILLING = 'billing',
  CONFIGURATION = 'configuration',
  TIERS = 'tiers',
  LOCATION_CATEGORIES = 'location-categories',
  OFFERS_CATEGORIES = 'offers-categories',
  ACCESS_DENIED = 'access-denied',
  COMING_SOON = 'coming-soon',
  STATUS = 'status',
  ORGANIZATION_CONFIGURATION = 'organization-configuration',
  VENDORS = 'vendors',
  AMBASSADORS = 'ambassadors',
  AMBASSADOR_CODES = 'ambassador-codes',
  SUPPORT = 'support',
  TERMS = 'terms',
  PLANS = 'plans',
  ALL = 'all',
  ADMIN = 'admin',
  USER = 'user',
  MY_OFFERS = 'my-offers',
  PUBLIC_OFFERS = 'public-offers',
  LOCATION_OFFERS = 'location-offers',
  DASHBOARD = 'dashboard',
  LINK = 'link',
  EDIT_LOCATIONS = 'edit-locations',
  EDIT_BRANDS = 'edit-brands',
  MARKETS = 'markets',
  MARKET_MANAGEMENT = 'market-management',
  ZIP_CODES = 'zip-codes',

  APPROVED = 'approved',
  REJECTED = 'rejected',
  PENDING = 'pending',
  PUBLISHING = 'publishing',
  CONFIGURED = 'configured',
  FAILED = 'failed',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  EXPIRED = 'expired',
  RECALLED = 'recalled',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  LINKED = 'linked',
  UNLINKED = 'unlinked',
  OPENED = 'opened',
  IN_PROGRESS = 'in-progress',
  CLOSED = 'closed',

  PROFILE = 'profile',

  PRODUCTS = 'products',
  PRODUCTS_MERCHANT = 'merchant',
  PRODUCTS_SYNONYMS = 'synonyms',

  ADD = 'add',
  EDIT = 'edit',
  VIEW = ':id',
  DETAIL = 'detail',
  COPY = 'copy',
  IMPORT = 'import',
  CREATE = 'create',
  LANDING = 'landing',
  PREVIEW = 'preview',
}
